<template>
    <div>Hello Payment!</div>
</template>

<script>
    export default {}
</script>